var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3065_8451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6348 18.8645C21.6137 20.4962 23.1163 21.4067 24.2482 21.9481C25.4112 22.5035 25.8018 22.8597 25.7972 23.3564C25.7886 24.1166 24.8696 24.4521 24.0096 24.4651C22.5093 24.488 21.6369 24.0676 20.9434 23.7496L20.4029 26.2318C21.0987 26.5465 22.3872 26.821 23.7232 26.833C26.8594 26.833 28.9112 25.3136 28.9223 22.9577C28.9346 19.9679 24.7087 19.8024 24.7376 18.466C24.7476 18.0608 25.1415 17.6283 26.0048 17.5184C26.4321 17.4628 27.6117 17.4203 28.949 18.0248L29.4739 15.6232C28.7547 15.3662 27.8304 15.12 26.6795 15.12C23.7277 15.12 21.6515 16.6602 21.6348 18.8645ZM34.5175 15.3269C33.9449 15.3269 33.4623 15.6548 33.2469 16.1579L28.767 26.6566H31.9009L32.5245 24.965H36.3541L36.7159 26.6566H39.478L37.0677 15.3269H34.5175ZM34.956 18.3875L35.8604 22.6419H33.3835L34.956 18.3875ZM17.8351 15.3271L15.3648 26.6565H18.3511L20.8203 15.3268H17.8351M13.4172 15.3268L10.3089 23.0384L9.0515 16.4815C8.90397 15.7496 8.32133 15.3269 7.67431 15.3269H2.59314L2.52197 15.6559C3.56512 15.8781 4.75031 16.2364 5.46835 16.6198C5.90778 16.854 6.03309 17.0587 6.17745 17.6153L8.55895 26.6566H11.7148L16.5532 15.3269H13.4172",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3065_8451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.96,
    height: 11.76,
    fill: "white",
    transform: "translate(2.52002 15.1201)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7e2066a127802cbf807cdd9e00d22f2a.svg";
export { ForwardRef as ReactComponent };